import React from 'react';
export function FAQSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative overflow-hidden py-24 bg-blue-950" data-id="element-21">
      <div className="absolute inset-0 opacity-5" data-id="element-22">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-amber-400 rounded-full blur-3xl" data-id="element-23" />
        <div className="absolute bottom-0 right-1/4 w-72 h-72 bg-blue-400 rounded-full blur-3xl" data-id="element-24" />
      </div>
      <div className="relative z-10 container mx-auto px-4 text-center" data-id="element-25">
        <span className="inline-block bg-amber-400 text-blue-900 text-xs font-extrabold px-4 py-1.5 rounded-full uppercase tracking-widest mb-6" data-id="element-26">
          ¿Listo para empezar?
        </span>
        <h3 className="text-3xl md:text-4xl font-extrabold text-white mb-4" data-id="element-27">
          Transformá tu año escolar hoy
        </h3>
        <p className="text-blue-200 text-lg mb-10 max-w-md mx-auto" data-id="element-28">
          Únete a cientos de docentes que ya organizaron su año de Derecho sin
          estrés
        </p>
        <button onClick={scrollToPricing} className="bg-amber-400 text-blue-900 font-extrabold text-lg px-10 py-4 rounded-xl shadow-xl hover:bg-amber-300 transition-all duration-200 inline-flex items-center gap-3" data-id="element-29">
          <span data-id="element-30">👉</span>
          QUIERO EMPEZAR AHORA
        </button>
        <p className="text-blue-300 text-sm mt-5" data-id="element-31">
          Descarga inmediata · Garantía de 7 días · Acceso de por vida
        </p>
      </div>
    </section>;
}